import React, { Component, Fragment } from 'react';
import { Menu, Button, Col } from 'antd';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { history } from '../../container/History';
import './layout.css';
import { QuestionOutlined } from '@ant-design/icons';
import MobileNavigation from "./MobileNavigation"

const ButtonGroup = Button.Group;

const nave = [
  { name: "Dashboard", link: "/admin-dashboard" },
  // { name: "Quick Search", link: "/quick-search" },
  { name: "Lists and Advanced Search", link: "/list-and-search" },
  { name: "Pending Membership", link: "/pending-membership" },
  { name: "Record Repair Tool", link: "/record-repair" },
  { name: "ALUMNI", link: "/alumni-dashboard" },
  { name: "Bulk Upload", link: "/bulk-upload" },
  { name: "Manage Roles", link: "/manage-roles" }
]

class AdminNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      panelView: null
    }
    this.changeview = this.changeview.bind(this)
  }

  componentDidMount = () => {
    let getPanelView = localStorage.getItem("panelView") ? JSON.parse(localStorage.getItem("panelView")) : "alumniTabView"
    this.setState({
      panelView: getPanelView
    })
    this.props.actions.isadmin()
  }

  changeview = (panelView) => {
    if (panelView != 'alumniTabView') {
      localStorage.setItem("panelView", JSON.stringify("alumniTabView"))
      // this.props.actions.ChangePanelView("alumniTabView")
      history.push('/alumni-dashboard')
    } else if (panelView === 'alumniTabView' || panelView === 'specialistTabView') {
      localStorage.setItem("panelView", JSON.stringify("adminTabView"))
      // this.props.actions.ChangePanelView("alumniTabView")
      history.push('/admin-dashboard')
    }
    // else{
    // let TabView = this.props.isadmin ? 'adminTabView' : this.props.isspecialist ? 'specialistTabView' : ''
    // this.props.actions.ChangePanelView(TabView)
    //  history.push('/admin-dashboard')
    // }
  }

  goToNeedSection = () => {
    history.push('/need-help')
  }

  static propTypes = {
    location: PropTypes.object.isRequired
  }

  renderMenuItems = () => {
    if (this.props.isSuperAlumniAdmin) {
      return [
        { key: "/pending-membership", label: "Manage Membership" },
        { key: "/record-repair", label: "Record Repair Tool" },
        { key: "/bulk-upload", label: "Bulk Upload" },
        { key: "/manage-roles", label: "Manage Roles" }
      ];
    } else {
      return [];
    }
  };

  render() {
    const { location, isSuperAlumniAdmin, isspecialist, isAlumniAdmin, isCSTSupport, isCouncilCommittee } = this.props;

    let roleToShow = null;

    if (isSuperAlumniAdmin) {
      roleToShow = "SUPER ADMIN";
    } else if (isspecialist) {
      roleToShow = "SPECIALIST";
    } else if (isAlumniAdmin) {
      roleToShow = "ALUMNI ADMIN";
    } else if (isCSTSupport) {
      roleToShow = "CST SUPPORT";
    } else if (isCouncilCommittee) {
      roleToShow = "COUNCIL COMMITTEE";
    }

    const shouldShowRoleTab = !!roleToShow;
    return (
      <Fragment >
        <div className="hidden-sm">
          <div className="ant-layout-wrapper">
            <Menu mode="horizontal" selectedKeys={[location.pathname]} defaultSelectedKeys={['/']} style={{ marginLeft: 124 }}>
              <Menu.Item key="/admin-dashboard"> <NavLink to="/admin-dashboard"> Dashboard </NavLink> </Menu.Item>
              {/* {this.props.isSuperAlumniAdmin && ( 
                <Menu.Item key="/quick-search"> <NavLink to="/quick-search"> Quick Search  </NavLink> </Menu.Item>
              )} */}
              <Menu.Item key="/list-and-search"> <NavLink to="/list-and-search"> Lists and Advanced Search </NavLink> </Menu.Item>
              {this.renderMenuItems().map(item => (
                <Menu.Item key={item.key}>
                  <NavLink to={item.key}>{item.label}</NavLink>
                </Menu.Item>
              ))}
              {/* <Menu.Item key="/pending-membership"> <NavLink to="/pending-membership"> Manage Membership </NavLink> </Menu.Item>
                <Menu.Item key="/record-repair"> <NavLink to="/record-repair"> Record Repair Tool </NavLink> </Menu.Item>
                <Menu.Item key="/bulk-upload"> <NavLink to="/bulk-upload"> Bulk Upload </NavLink> </Menu.Item>
                <Menu.Item key="/manage-roles"> <NavLink to="/manage-roles"> Manage Roles </NavLink> </Menu.Item> */}
            </Menu>

            {(this.props.isadmin || this.props.isspecialist) &&
              <div className='loggedin-user'>
                <ButtonGroup className='role-btn'>
                  <span className="ant-btn ant-btn-scout-btn " onClick={() => this.changeview(this.state.panelView)} type="scout-btn"> ALUMNI </span>
                  {
                    // this.props.postionsinfo && this.props.postionsinfo.length > 0 ? (
                    //   (() => {
                    //     const contextPriority = ['AlumniAdmin', 'AlumniCSTSupport', 'AlumniCouncilCommittee'];
                    //     const roleMap = {
                    //       AlumniAdmin: 'ALUMNI ADMIN',
                    //       AlumniCSTSupport: 'CST SUPPORT',
                    //       AlumniCouncilCommittee: 'COUNCIL COMMITTEE'
                    //     };

                    //     const highestPriority = contextPriority.find(priority =>
                    //       this.props.postionsinfo.some(info => info.personContext === priority)
                    //     );

                    //     return highestPriority ? (
                    //       <span className="active ant-btn ant-btn-scout-btn" type="scout-btn">
                    //         {roleMap[highestPriority]}
                    //       </span>
                    //     ) : null;
                    //   })()
                    // ) : (
                      <div>
                        {/* <span className="active ant-btn ant-btn-scout-btn" type="scout-btn">
                          {this.props.isSuperAlumniAdmin ? "SUPER ADMIN" : ""}
                          {this.props.isAlumniAdmin ? "ALUMNI ADMIN" : ""}
                          {this.props.isCSTSupport ? "CST SUPPORT" : ""}
                          {this.props.isCouncilCommittee ? "COUNCIL COMMITTE" : ""}
                          {this.props.isspecialist ? "SPECIALIST" : ""}
                        </span> */}
                        {shouldShowRoleTab && (
                          <span className="active ant-btn ant-btn-scout-btn" type="scout-btn">
                            {roleToShow}
                          </span>
                        )}
                      </div>
                    // )
                  }
                </ButtonGroup>
              </div>
            }

            {
              (this.props.isspecialist) &&
              <div className='Need-Help-Section'>
                <button className='Need-help-action' onClick={this.goToNeedSection} > NEED HELP
                  <i class="fa fa-question-circle" aria-hidden="true"></i>
                </button>
              </div>
            }

          </div>
        </div>
        <Col className="breadcrumbMenu visible-xs">
          <MobileNavigation nave={nave} />
        </Col>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    logout: state.authenticationReducer.logout,
    profileinfo: state.profilereducer.profileinfo,
    isadmin: state.isadminreducer.isadmin,
    isspecialist: state.isadminreducer.isspecialist,
    isSuperAlumniAdmin: state.isadminreducer.isSuperAlumniAdmin,
    isCSTSupport: state.isadminreducer.isCSTSupport,
    isCouncilCommittee: state.isadminreducer.isCouncilCommittee,
    isAlumniAdmin: state.isadminreducer.isAlumniAdmin,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(AdminNavigation);



// WEBPACK FOOTER //
// ./src/components/Inc/AdminNavigation.js